var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{},[_c('div',{staticClass:"border border-light rounded-circle d-flex justify-content-center align-items-center bg-primary text-white",style:(_vm.style)},[_c('span',{staticClass:"justify-content-center"},[_vm._v(" "+_vm._s(_vm.shortName)+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }